export const REDUCER_ACTION_TYPES = {
  CHANGE_DATE_RANGE: "CHANGE_DATE_RANGE",
  UPDATE_CALENDAR_SCHEDULES: "UPDATE_CALENDAR_SCHEDULES",
  CHANGE_FILTER_SPORT_COURT: "CHANGE_FILTER_SPORT_COURT",
  CHANGE_FILTER_STATUS: "CHANGE_FILTER_STATUS",
  CHANGE_FILTER_CUSTOMER: "CHANGE_FILTER_CUSTOMER",
  REFRESH_CALENDAR: "REFRESH_CALENDAR",
  UPDATE_EVENT: "UPDATE_EVENT",
} as const;
